import { PurchaseOverviewPage, PurchaseOrderPage } from "@clubInventory/purchase";
import { CLUB_INVENTORY_ROUTER } from "./routerPath";
import { FRONT_KEY } from "@clubInventory/constants/frontKey";

/**
 * 進貨管理路由配置
 */
const purchaseRouter = [
	{
		description: "進貨總覽",
		exact: true,
		path: CLUB_INVENTORY_ROUTER.PURCHASE.OVERVIEW,
		href: CLUB_INVENTORY_ROUTER.PURCHASE.OVERVIEW,
		as: PurchaseOverviewPage,
		frontKey: FRONT_KEY.PURCHASE_OVERVIEW,
	},
	{
		description: "進貨單",
		exact: true,
		path: CLUB_INVENTORY_ROUTER.PURCHASE.ORDER,
		as: PurchaseOrderPage,
		frontKey: FRONT_KEY.PURCHASE_ORDER,
	},
];

export default purchaseRouter;
